import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AppConfig {
    // data members

    private configuration: any;

    private _isLoaded: boolean = false;
    get isLoaded(): boolean {
        return this._isLoaded;
    }

    // constructor

    constructor(private httpClient: HttpClient) {}

    // public functions

    public getValue(key: any) {
        return this.configuration[key];
    }

    public load(url: string) {
        return new Promise<void>((resolve) => {
            this.httpClient.get<any>(url).subscribe((configuration) => {
                this.configuration = configuration;
                this._isLoaded = true;
                resolve();
            });
        });
    }
}
